export const notificationsSettingsStyle = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
	},
	smsDisclosure: {
		maxWidth: '620px',
		margin: '8px 16px 0',
	},
	smsDisclosureText: {
		color: 'var(--neutral-300)',
		fontSize: '12px',
		lineHeight: '18px',
	},
	smsLinks: {
		display: 'flex',
		gap: '8px',
		marginTop: '4px',
	},
	smsLink: {
		color: 'var(--primary-500)',
		fontSize: '12px',
		lineHeight: '18px',
		textDecoration: 'none',
		'&:hover': {
			textDecoration: 'underline',
		},
	},
	smsSeparator: {
		color: 'var(--neutral-300)',
		fontSize: '12px',
		lineHeight: '18px',
	},
	detailsModal: {
		'.MuiPaper-root': {
			position: 'relative',
			maxWidth: '971px',
			width: '100%',
			maxHeight: '652px',
			height: '100%',
			scrollbarGutter: 'stable',
			borderRadius: '8px',
			padding: '48px 190px',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-between',

			'@media (max-width: 1199.98px)': {
				padding: '48px 60px',
			},

			'@media (max-width: 639.98px)': {
				padding: '40px 20px 20px 20px',
			},

		},
	},
};
